import { Dices } from 'lucide-react';
import { generateStrongPassword } from '../../shared/utils/passwordGenerator';
import { useToast } from '../../shared/hooks/useToast';
import styles from './PasswordGeneratorButton.module.css';

export type PasswordGeneratorButtonProps = {
  onGenerate: (password: string) => void;
  disabled?: boolean;
  length?: number;
};

export function PasswordGeneratorButton({ onGenerate, disabled, length }: PasswordGeneratorButtonProps) {
  const toast = useToast();
  function handleClick() {
    const pwd = generateStrongPassword(length);
    onGenerate(pwd);
    toast.info('Senha forte gerada. Copie e guarde em local seguro.', {
      title: '🎲 Senha gerada',
    });
  }
  return (
    <button
      type="button"
      className={styles.btn}
      onClick={handleClick}
      disabled={disabled}
      aria-label="Gerar senha forte"
      title="Gerar senha forte"
    >
      <Dices size={18} />
    </button>
  );
}
